import React, { useState } from "react";
import { href, Link } from "react-router-dom";
import { MdOutlineArrowOutward } from "react-icons/md";
import Logo from "../image/logo2.png";
import SearchBox from "./SearchBox";

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileActiveDropdown, setMobileActiveDropdown] = useState(null);
  let closeTimeout = null;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setActiveDropdown(null);
    setMobileActiveDropdown(null);
  };

  const handleMouseEnter = (menu) => {
    clearTimeout(closeTimeout);
    setActiveDropdown(menu);
  };

  const handleMouseLeave = () => {
    closeTimeout = setTimeout(() => {
      setActiveDropdown(null);
    }, 200);
  };

  const toggleMobileDropdown = (menu) => {
    if (mobileActiveDropdown === menu) {
      setMobileActiveDropdown(null);
    } else {
      setMobileActiveDropdown(menu);
    }
  };

  /* ---------------- Dropdown Data ---------------- */

  const policyDialoguesItems = [
    { title: "Public Health", href: "/policy/public-health" },
    { title: "Policy Astrology & Analytics", href: "/policy/policy-analytics" },
    { title: "MedTech & SaMD", href: "/policy/medtech-samd" },
    { title: "Industry Leadership", href: "/policy/industry-leadership" },
    { title: "Capacity Building for Viksit Bharat 2047", href: "/policy/viksit-bharat-2047" },
    { title: "Diagnostics and IVD", href: "/policy/diagnostics-ivd" },
    { title: "Global Collaborations & Outreach", href: "/policy/global-collaborations" },
    { title: "Health Finance & Insurance", href: "/policy/health-finance-insurance" },
    { title: "Services Exports (MVT, HealthTech, etc.)", href: "/policy/services-exports" },
    { title: "Digital Health", href: "/policy/digital-health" },
    { title: "Procurement, Supply Chain & Logistics", href: "/policy/procurement-supply-chain" },
    { title: "Pharmaceuticals", href: "/policy/pharmaceuticals" },
    { title: "Quality, Innovation, Startups & Sustainability", href: "/policy/quality-innovation-startups" },
    { title: "Industry–Academia–Government Partnership", href: "/policy/industry-academia-government" },
    { title: "Skill Development", href: "/policy/skill-development" },
    { title: "Organ Donation Endeavors", href: "/policy/organ-donation" },
    { title: "PwDs & Assistive Technologies", href: "/policy/assistive-technologies" },
    { title: "Healthcare Journals", href: "/policy/healthcare-journals" },
    { title: "Health Economics & Statistics", href: "/policy/health-economics-statistics" },
    { title: "Genomics", href: "/policy/genomics" },
    { title: "Strategic Conferences & Conclaves", href: "/policy/conferences-conclaves" },
    { title: "VUCA Watch", href: "/policy/vuca-watch" },
  ];

  const associationsItems = [
    { title: "Industry Associations", href: "/associations/academic" },
    { title: "Foundations", href: "/associations/healthcare" },
    { title: "Government & Think Tanks", href: "/associations/government" },
  ];

 const publicationItems = [
  {
    title: "9VOM Publishing",href: "https://www.9vom.in/",
  },
];


  return (
    <nav className="bg-white shadow-lg w-full">
      <div className="max-w-7xl mx-auto px-2 lg:px-6">

        {/* ================= TOP ROW ================= */}
        <div className="flex justify-between items-center h-20">
          {/* Logo - Left */}
          <Link to="/" className="flex flex-col items-center">
            <img src={Logo} alt="Logo" className="h-[46px] w-auto" />
            <span className="text-blue-900 font-semibold text-sm mt-1 mr-[10px]">
              Democratizing Public Health Advocacy
            </span>
          </Link>

          {/* CTA - Right (Desktop) */}
          <div className="hidden lg:flex items-center gap-4">
            <SearchBox />
          {/*  <Link to="/contact">
              <button className="flex items-center gap-2 bg-orange-600 text-white px-5 py-2 rounded-md hover:bg-orange-700 transition">
                Join the Dialogue <MdOutlineArrowOutward />
              </button>
            </Link> */}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={toggleMobileMenu} className="lg:hidden">
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMobileMenuOpen ? (
                <path strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* ================= GREY DIVIDER ================= */}
        <div className="border-t border-gray-200"></div>

        {/* ================= DESKTOP MENU ================= */}
        <div className="hidden lg:flex justify-center items-center space-x-8 font-semibold h-14">

          <Link to="/" className="text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
            Home
          </Link>
          <Link to="/about" className="text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
            About Us
          </Link>
{/*Policy Dialogues Dropdown */}
              <Link to="/policy-dialogues" className="text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
           Policy Dialogues Focus
          </Link>

          {/* Policy Dialogues Dropdown 
          <div 
            className="relative"
            onMouseEnter={() => handleMouseEnter("policy")}
            onMouseLeave={handleMouseLeave}
          >
            <button className="flex items-center text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
              <span className="text-red-500">Policy</span>Dialogues <span className="text-red-500">Focus</span>
              <svg className={`ml-1 h-4 w-4 transition-transform duration-200 ${activeDropdown === 'policy' ? 'rotate-180' : ''}`} 
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <div 
              className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-3 w-96 bg-white rounded-lg shadow-xl border border-gray-200 z-50 transition-all duration-200 
                ${activeDropdown === 'policy' ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
              onMouseEnter={() => handleMouseEnter("policy")}
              onMouseLeave={handleMouseLeave}
            >
              <div className="max-h-[500px] overflow-y-auto py-2">
                {policyDialoguesItems.map((item, i) => (
                  <React.Fragment key={i}>
                    <Link
                      to={item.href}
                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200 group"
                    >
                      <div className="flex justify-between items-center">
                        <span>{item.title}</span>
                        <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200 transform group-hover:translate-x-1" 
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </Link>
                    {i < policyDialoguesItems.length - 1 && (
                      <div className="border-t border-gray-100 mx-4"></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>  */}

        {/*Publication 
         <div 
  className="relative"
  onMouseEnter={() => handleMouseEnter("publications")}
  onMouseLeave={handleMouseLeave}
>
  <button className="flex items-center text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
    Publications
    <svg className={`ml-1 h-4 w-4 transition-transform duration-200 ${activeDropdown === 'publications' ? 'rotate-180' : ''}`} 
      fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <div 
    className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-3 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-50 transition-all duration-200 
      ${activeDropdown === 'publications' ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
    onMouseEnter={() => handleMouseEnter("publications")}
    onMouseLeave={handleMouseLeave}
  >
    <div className="py-2">
      {publicationItems.map((item, i) => (
        <React.Fragment key={i}>
          <Link
            to={item.href}
            className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200 group"
          >
            <div className="flex justify-between items-center">
              <span>{item.title}</span>
              <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200 transform group-hover:translate-x-1" 
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>
          {i < publicationItems.length - 1 && (
            <div className="border-t border-gray-100 mx-4"></div>
          )}
        </React.Fragment>
      ))}
    </div>
  </div>
</div>  */}

{/*Publications */}
           <Link to="/publications" className="text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
            Publications
          </Link>

          {/*Events Media*/}
          <Link to="/events" className="text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
          News & Events
          </Link>

          {/*Advisory Board*/}
          <Link to="/advisory-board" className="text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
            Advisory Board
          </Link>

          {/* Associations Dropdown */}
            <Link to="/association" className="text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
            Associations
          </Link>

         {/* <div 
            className="relative"
            onMouseEnter={() => handleMouseEnter("associations")}
            onMouseLeave={handleMouseLeave}
          >
            <button className="flex items-center text-gray-700 hover:text-blue-700 transition-colors duration-200 px-2 py-1">
              Associations
              <svg className={`ml-1 h-4 w-4 transition-transform duration-200 ${activeDropdown === 'associations' ? 'rotate-180' : ''}`} 
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <div 
              className={`absolute top-full left-0 mt-3 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-50 transition-all duration-200 
                ${activeDropdown === 'associations' ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
              onMouseEnter={() => handleMouseEnter("associations")}
              onMouseLeave={handleMouseLeave}
            >
              <div className="py-2">
                {associationsItems.map((item, i) => (
                  <React.Fragment key={i}>
                    <Link
                      to={item.href}
                      className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200 group"
                    >
                      <div className="flex justify-between items-center">
                        <span>{item.title}</span>
                        <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200 transform group-hover:translate-x-1" 
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </Link>
                    {i < associationsItems.length - 1 && (
                      <div className="border-t border-gray-100 mx-4"></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>*/}
        </div>

        {/* ================= MOBILE & TABLET MENU ================= */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 mt-2">
            <div className="space-y-0 py-4">
              <Link 
                to="/" 
                className="block px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Home
              </Link>
              
              <Link 
                to="/about" 
                className="block px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                About Us
              </Link>
               

                 <Link 
                to="/policy-dialogues" 
                className="block px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Policy Dialogues Focus
              </Link>
              {/* Policy Dialogues Mobile Dropdown 
              <div className="border-b border-gray-100">
                <button
                  onClick={() => toggleMobileDropdown("policy")}
                  className="w-full flex justify-between items-center px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200"
                >
                  <span>
                    <span className="text-red-500">Policy</span>Dialogues<span className="text-red-500">Focus</span>
                  </span>
                  <svg
                    className={`h-4 w-4 transition-transform duration-200 ${mobileActiveDropdown === 'policy' ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {mobileActiveDropdown === "policy" && (
                  <div className="bg-white rounded-b-lg shadow-inner">
                    <div className="max-h-[400px] overflow-y-auto py-2">
                      {policyDialoguesItems.map((item, i) => (
                        <React.Fragment key={i}>
                          <Link
                            to={item.href}
                            className="block px-8 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200 group"
                            onClick={toggleMobileMenu}
                          >
                            <div className="flex justify-between items-center">
                              <span>{item.title}</span>
                              <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200 transform group-hover:translate-x-1" 
                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </div>
                          </Link>
                          {i < policyDialoguesItems.length - 1 && (
                            <div className="border-t border-gray-100 mx-8"></div>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                )}
              </div> */}

                {/*PUblication

                    <div className="border-b border-gray-100">
                <button
                  onClick={() => toggleMobileDropdown("publications")}
                  className="w-full flex justify-between items-center px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200"
                >
                  <span>Publications</span>
                  <svg
                    className={`h-4 w-4 transition-transform duration-200 ${mobileActiveDropdown === 'publications' ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {mobileActiveDropdown === "publications" && (
                  <div className="bg-white rounded-b-lg shadow-inner">
                    <div className="py-2">
                      {publicationItems.map((item, i) => (
                        <React.Fragment key={i}>
                          <Link
                            to={item.href}
                            className="block px-8 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200 group"
                            onClick={toggleMobileMenu}
                          >
                            <div className="flex justify-between items-center">
                              <span>{item.title}</span>
                              <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200 transform group-hover:translate-x-1" 
                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </div>
                          </Link>
                          {i < publicationItems.length - 1 && (
                            <div className="border-t border-gray-100 mx-8"></div>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                )}
              </div> */}

               <Link 
                to="/publications" 
                className="block px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Publications
              </Link>
              
              <Link 
                to="/events" 
                className="block px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                News & Events
              </Link>
              
              <Link 
                to="/advisory-board" 
                className="block px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Advisory Board
              </Link>

              {/* Associations Mobile Dropdown */}
                <Link 
                to="/association" 
                className="block px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200 border-b border-gray-100"
                onClick={toggleMobileMenu}
              >
                Associations
              </Link>
               {/* <div className="border-b border-gray-100">
                <button
                  onClick={() => toggleMobileDropdown("associations")}
                  className="w-full flex justify-between items-center px-4 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-700 transition-colors duration-200"
                >
                  <span>Associations</span>
                  <svg
                    className={`h-4 w-4 transition-transform duration-200 ${mobileActiveDropdown === 'associations' ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {mobileActiveDropdown === "associations" && (
                  <div className="bg-white rounded-b-lg shadow-inner">
                    <div className="py-2">
                      {associationsItems.map((item, i) => (
                        <React.Fragment key={i}>
                          <Link
                            to={item.href}
                            className="block px-8 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200 group"
                            onClick={toggleMobileMenu}
                          >
                            <div className="flex justify-between items-center">
                              <span>{item.title}</span>
                              <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200 transform group-hover:translate-x-1" 
                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </div>
                          </Link>
                          {i < associationsItems.length - 1 && (
                            <div className="border-t border-gray-100 mx-8"></div>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                )}
              </div> */}

              {/* Mobile Search Box */}
              <div className="px-4 py-3 border-b border-gray-100">
                <div className="mb-4">
                  <SearchBox />
                </div>
              </div>

              {/* Mobile CTA Button */}
              <div className="px-4 pt-4 pb-4 bg-gray-50">
                <Link to="/contact" onClick={toggleMobileMenu}>
                  <button className="w-full flex items-center justify-center gap-2 bg-orange-600 text-white px-5 py-3 rounded-md hover:bg-orange-700 transition">
                    Join the Dialogue <MdOutlineArrowOutward />
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;